import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '../../api';

const removeOrderItem = async ({ productId, userId }) => {
    // Находим последнюю запись order_items по productId и userId
    const { data, error } = await supabase
        .from('order_items')
        .select('id, order_id')
        .eq('product', productId)
        .order('created_at', { ascending: false }) // Сортируем по дате добавления, чтобы удалить последнюю запись
        .limit(1)
        .single();

    if (error || !data) {
        throw new Error(`No item found to remove: ${error?.message || 'Not found'}`);
    }

    // Удаляем найденную запись
    const { error: deleteError } = await supabase
        .from('order_items')
        .delete()
        .eq('id', data.id);

    if (deleteError) {
        throw new Error(`Failed to remove item: ${deleteError.message}`);
    }

    return data;
};

export default function useRemoveProductFromBasket() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: removeOrderItem,
        onSuccess: () => {
            queryClient.invalidateQueries(['useGetOrdersInTheCart']);
            queryClient.invalidateQueries(['useGetOrders']);
        }
    });
}
